import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	companies: [],
	companiesMap: {},
	company: {
		company: null,
		products: [],
		promos: [],
		additions: [],
	},
};

export const companiesSlice = createSlice({
	name: 'companies',
	initialState,
	reducers: {
		setCompanies: (state, action) => {
			state.companies = action.payload;
			state.companiesMap = action.payload.reduce((acc, company) => {
				acc[company.id] = company;
				return acc;
			}, {});
		},
		setCompany: (state, action) => {
			state.company.company = action.payload;
		},
		setProducts: (state, action) => {
			state.company.products = action.payload;
		},
		setPromos: (state, action) => {
			state.company.promos = action.payload;
		},
		setAdditions: (state, action) => {
			state.company.additions = action.payload;
		},
	},
});

export const {
	setCompanies,
	setCompany,
	setProducts,
	setPromos,
	setAdditions,
} = companiesSlice.actions;

export default companiesSlice.reducer;
